import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const wasteHandoverRegistrationPrintRoutes = ({
    PrintPDF,
}: {
    PrintPDF: React.ComponentType;
}) => (
    <Routes>
        <Route path={ROUTES.WASTE_HANDOVER_REGISTRATION_PRINT.CONTENT} element={<PrintPDF />} />
    </Routes>
);

